import { useParams } from 'react-router-dom';

import LessonAlerts from '@/components/shared/NegativeAlerts/Lesson';
import { useLessonCount } from '@/hooks/useLessonCount';
import { blockedStatus } from '@/interfaces/course';
import { lessonsApi } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

import LessonType from './Types';

function LessonArea({ className }: StyledProp) {
  const { id } = useParams();
  const { data, isFetching } = lessonsApi.endpoints.getLessons.useQueryState(id);
  const { lessonCount } = useLessonCount();

  if (isFetching) return null;

  if (blockedStatus.includes(data?.status) || (!data?.allow_multiple_access && lessonCount > 1)) {
    return (
      <div className={className}>
        <LessonAlerts />
      </div>
    );
  }

  return (
    <div className={className}>
      {(data?.contents ?? []).map((content, index) => (
        <LessonType key={index} {...content} />
      ))}
    </div>
  );
}

export default styled(LessonArea)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.spacing(9)};
  min-height: 400px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.pxToRem(32)};

  img {
    width: 100%;
  }
`;
